import { useState, useEffect } from "react";
import { errorLabels } from "../../../../../utils/helpers";
import { ErrorMessage } from "../../../../../utils/toastify";
import { useFormRCSPartnerErrorsLog } from "./useFormRCSPartnerErrorsLog";
import { useFetchRCSPartnerErrorsLogs } from "./useFetchRCSPartnerErrorsLogs";

export const useRCSReportErrorsByPartners = () => {
  const { mutate, isPending, data = [] } = useFetchRCSPartnerErrorsLogs();

  const [reset, setReset] = useState(false);
  const formik = useFormRCSPartnerErrorsLog({
    onSubmit: mutate,
  });

  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  const handleReset = () => {
    formik.resetForm();
    setReset(true);
  };

  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [reset]);

  return {
    formik,
    reset,
    isLoading: isPending,
    _validate,
    handleReset,
    data,
  };
};
